import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.sub";
import { changePassword } from '@/api/login';
import admin from '@/api/admin/admin';
export default {
  name: 'ChangePassword',
  props: {
    userName: {
      type: String,
      default: ''
    },
    pwd: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    }
  },
  emits: ['passwordChangeIf'],
  data: function data() {
    var _this = this;
    var validatePassword = function validatePassword(rule, value, callback) {
      var isnum = /^\d+$/.test(value);
      if (value.length !== 6 || !isnum) {
        callback(new Error('Şifre 6 haneli olmalı ve yalnızca rakamlardan oluşmalıdır.'));
      } else {
        callback();
      }
    };
    var validateMatch = function validateMatch(rule, value, callback) {
      if (_this.model.oldPassword === _this.model.newPassword) {
        callback(new Error('Eski şifre ile yeni şifre aynı olamaz'));
      }
      if (_this.model.newPassword !== _this.model.newPasswordAgain) {
        callback(new Error('Girilen şifreler eşleşmiyor! '));
      } else {
        callback();
      }
    };
    return {
      passwordType: 'password',
      passwordAgainType: 'password',
      model: {
        oldPassword: '',
        newPassword: '',
        newPasswordAgain: '',
        id: this.$store.state.user.sub
      },
      validation: {
        oldPassword: [{
          required: true,
          message: 'Bu alanı boş bırakmayınız.'
        }],
        newPassword: [{
          validator: validatePassword,
          message: 'Şifrenizi kurallara uygun giriniz.',
          trigger: 'change'
        }, {
          required: true,
          message: 'Şifrenizi kurallara uygun giriniz.',
          trigger: 'change'
        }],
        newPasswordAgain: [{
          validator: validateMatch,
          trigger: 'blur'
        }, {
          required: true,
          message: 'Yeni şifrenizi tekrar giriniz.'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.model.oldPassword = '';
    this.model.newPassword = '';
    this.model.newPasswordAgain = '';
    this.model.oldPassword = this.pwd;
  },
  methods: {
    showPwd: function showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
    },
    showAgainPwd: function showAgainPwd() {
      if (this.passwordAgainType === 'password') {
        this.passwordAgainType = '';
      } else {
        this.passwordAgainType = 'password';
      }
    },
    logout: function logout() {
      var _this2 = this;
      this.$store.dispatch('LogOut').then(function () {
        _this2.$router.push('/');
        // In order to re-instantiate the vue-router object to avoid bugs
      });
    },
    updatePassword: function updatePassword() {
      var _this3 = this;
      if (this.model.newPassword !== this.model.newPasswordAgain) {
        this.$notify.error('Girilen şifreler eşleşmiyor!');
        return;
      }
      if (this.busy === true) return;
      if (this.userName) {
        this.model.id = this.userName;
      }
      this.$refs['passwordChange'].validate(function (valid) {
        if (valid) {
          _this3.busy = true;
          var changeModel = {
            userName: _this3.userName,
            oldPassword: _this3.model.oldPassword,
            newPassword: _this3.model.newPassword,
            reNewPassword: _this3.model.newPasswordAgain,
            token: _this3.token
          };
          var method = _this3.token ? changePassword(changeModel) : admin.updatePassword(_this3.model);
          method.then(function (v) {
            if (v.data.success === false) {
              if (v.data.errorMessage !== null) {
                if (v.data.errorMessage === 'passwordDoesNotMatch') {
                  _this3.$notify.error('Eski şifrenizi kontrol ediniz!');
                } else if (v.data.errorMessage === 'passwordDoesntMeetRequirements') {
                  _this3.$notify.error('Yeni şifreniz kriterleri sağlamamaktadır lütfen kontrol ediniz!');
                } else if (v.data.errorMessage === 'fillEmptyFields') {
                  _this3.$notify.error('Boş alan bırakmayınız!');
                } else if (v.data.errorMessage === 'Same Password') {
                  _this3.$notify.error('Belirlediğiniz şifre eski şifrenizden farklı olmalıdır!');
                }
              }
            } else {
              _this3.$emit('passwordChangeIf', false);
              _this3.showOk = true;
              setTimeout(function () {
                _this3.logout();
              }, 3000);
            }
          }).catch(function (err) {
            if (err.response.data.status === 500) {
              err.response.data.errors.DomainValidations.forEach(function (v) {
                // eslint-disable-next-line
                _this3.$notify.error(_this3.$t('hr.error.' + v + '  '));
              });
            } else {
              _this3.$notify.error(_this3.$t('notify.error'));
            }
            _this3.busy = false;
          }).finally(function () {
            _this3.busy = false;
          });
        }
      });
    }
  }
};